var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ul',{staticClass:"review-stars"},_vm._l((5),function(star,index){return _c('li',{key:star,staticClass:"rreview-stars__item",attrs:{"data-auto":"reviewStars"},on:{"click":function($event){return _setup.handleRating(star)}}},[_c(_setup.ReviewIconStar,{attrs:{"active":index + 1 <= _setup.props.rating}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }